import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import { BrowserRouter } from 'react-router-dom'



const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#004A87"   // "#0059b3"  //"#1976d2" 
    },
    secondary: {
      main: "#e60000"
    }
  },
  typography: {
    button: {
      textTransform: 'none'
    }
  },
  overrides: {
    // MuiList: {
    //   root: {
    //     // "&:hover": {
    //     //   backgroundColor: "#85C1E9"
    //     // },
    //     // fontSize: ".875rem"
    //   }
    // },
    MuiDataGrid: {
      root: {
        '& .MuiDataGrid-columnsContainer': {
          minHeight: '50px',
          maxHeight: '50px',
          lineHeight: '50px'
        },
        '& .MuiDataGrid-colCellWrapper': {
          backgroundColor: '#004A87',
          color: '#fff',  
          height: '40px'       
        },
       

      }
    },
    MuiAutocomplete: {
      root: {
        verticalAlignment:'center'
      }
    }

  }

})
ReactDOM.render(
  //  <React.StrictMode>  
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </BrowserRouter>,
  //  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
